<template>
    <main class="stats">
        <section class="list-banner">
            <div class="overlay"></div>
            <h1 class="banner-title">Trips</h1>
        </section>
        <SubMenu parent-route-name="stats" />
        <LoadingScreen v-if="!loaded" message="Loading trip statistics…" />
        <section v-else class="max-width-container">
            <article>
                <h2>Trips</h2>
                <DataTable :table="table" />
            </article>
            <article>
                <h2>Duration</h2>
                <BaseChart name="Duration" :options="durationChart" />
            </article>
            <article>
                <h2>Travel reason</h2>
                <BaseChart name="Travel reason" :options="reasonChart" />
            </article>
            <article>
                <h2>Travel agency</h2>
                <BaseChart name="Travel agency" :options="agencyChart" />
            </article>
        </section>
        <section class="actions">
            <router-link to="/stats">
                <Bttn class="outlined">Back</Bttn>
            </router-link>
        </section>
    </main>
</template>
<script>
import DataTable from "js/components/tables/DataTable";
import BaseChart from "js/components/charts/BaseChart";
import LoadingScreen from "js/components/common/LoadingScreen";
import { fetch } from "js/lib/server.js";
import { getSimpleBarChart } from "js/lib/charts.js";

export default {
    components: {
        LoadingScreen,
        DataTable,
        BaseChart,
    },
    data() {
        return {
            loaded: false,
            header: [],
            body: [],
            prefixes: {},
            reasonChart: {},
            agencyChart: {},
        };
    },
    mounted() {
        fetch("/api/stats/trips").then((response) => {
            this.table = response.data.table;

            this.reasonChart = getSimpleBarChart(
                "Trips",
                response.data.charts.reason.labels,
                response.data.charts.reason.lines.trips
            );
            this.agencyChart = getSimpleBarChart(
                "Trips",
                response.data.charts.travel_agency.labels,
                response.data.charts.travel_agency.lines.trips
            );
            this.durationChart = getSimpleBarChart(
                "Trips",
                response.data.charts.duration.labels,
                response.data.charts.duration.lines.trips
            );
            this.loaded = true;
        });
    },
};
</script>
